import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
`

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
`

export const TableHead = styled.thead`
  background-color: #046639;
  
  th {
    color: white;
    font-weight: 500;
    text-align: left;
    padding: 1rem;
    white-space: nowrap;
  }
`

export const TableBody = styled.tbody`
  tr:nth-child(odd) {
    background-color: #FAFAFA;
  }
  
  tr:nth-child(even) {
    background-color: #F5F5F5;
  }

  td {
    padding: 1.75rem 1rem;
    border-top: 1px solid #E0E0E0;
    color: #212121;

    &:first-child {
      font-weight: bold;
      color: #000000;
    }
  }
`

export const AccessLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #2196F3;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #757575;
  
  h3 {
    margin-bottom: 1rem;
  }
`

export const ErrorMessage = styled.div`
  color: #f44336;
  padding: 1rem;
  text-align: center;
  background-color: #ffebee;
  border-radius: 4px;
  margin: 1rem 0;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;
`
